/* ============================================================
   US state/territory centroids for NWSS (CONUS) scan-map markers,
   derived from the bundled us-atlas geometry (state names,
   lowercased). Generated from a standard dataset rather than
   hand-maintained. Abbreviation → name mapping lives in
   biothreatV2Geo.ts (US_STATE_ABBR).
   ============================================================ */
import type { LatLon } from "./biothreatV2Geo"

export const US_STATE_CENTROIDS: Record<string, LatLon> = {
  alabama: { lon: -86.73, lat: 31.8 },
  alaska: { lon: -151.45, lat: 60.34 },
  arizona: { lon: -113.72, lat: 34.5 },
  colorado: { lon: -105.65, lat: 38.91 },
  florida: { lon: -82.78, lat: 28.3 },
  georgia: { lon: -82.7, lat: 32.38 },
  indiana: { lon: -86.75, lat: 38.77 },
  kansas: { lon: -96.54, lat: 39.05 },
  maine: { lon: -69, lat: 44.83 },
  massachusetts: { lon: -70.94, lat: 42.03 },
  minnesota: { lon: -93.36, lat: 46.94 },
  "new jersey": { lon: -74.81, lat: 40.06 },
  "north carolina": { lon: -78.19, lat: 35.57 },
  "north dakota": { lon: -98.39, lat: 47.54 },
  oklahoma: { lon: -97.44, lat: 34.48 },
  pennsylvania: { lon: -76.23, lat: 40.99 },
  "south dakota": { lon: -98.17, lat: 43.72 },
  texas: { lon: -98.52, lat: 30.07 },
  wyoming: { lon: -108.36, lat: 43.37 },
  connecticut: { lon: -72.76, lat: 41.43 },
  missouri: { lon: -91.75, lat: 38.43 },
  "west virginia": { lon: -80.44, lat: 38.76 },
  illinois: { lon: -89.47, lat: 39.33 },
  "new mexico": { lon: -105.96, lat: 34.34 },
  arkansas: { lon: -91.26, lat: 34.58 },
  california: { lon: -120.27, lat: 36.68 },
  delaware: { lon: -75.47, lat: 39.29 },
  "district of columbia": { lon: -77.04, lat: 38.9 },
  hawaii: { lon: -155.52, lat: 19.61 },
  iowa: { lon: -93.65, lat: 41.88 },
  kentucky: { lon: -85.67, lat: 37.8 },
  maryland: { lon: -76.73, lat: 38.85 },
  michigan: { lon: -84.39, lat: 44.01 },
  mississippi: { lon: -90.6, lat: 32.61 },
  montana: { lon: -112.77, lat: 46 },
  "new hampshire": { lon: -71.66, lat: 43.88 },
  "new york": { lon: -75.07, lat: 42.59 },
  ohio: { lon: -82.4, lat: 39.83 },
  oregon: { lon: -121, lat: 44.7 },
  tennessee: { lon: -86.53, lat: 35.9 },
  utah: { lon: -111.61, lat: 39.51 },
  virginia: { lon: -78.57, lat: 37.72 },
  washington: { lon: -122.44, lat: 47.32 },
  wisconsin: { lon: -89.75, lat: 44.99 },
  "american samoa": { lon: -170.71, lat: -14.29 },
  guam: { lon: 144.77, lat: 13.46 },
  "commonwealth of the northern mariana islands": { lon: 145.75, lat: 15.18 },
  nebraska: { lon: -97.18, lat: 41.7 },
  "south carolina": { lon: -81.14, lat: 33.45 },
  "puerto rico": { lon: -66.43, lat: 18.2 },
  "united states virgin islands": { lon: -64.79, lat: 17.74 },
  idaho: { lon: -114.63, lat: 45.43 },
  nevada: { lon: -115.89, lat: 37.94 },
  vermont: { lon: -72.59, lat: 44.02 },
  louisiana: { lon: -91.13, lat: 30.49 },
  "rhode island": { lon: -71.52, lat: 41.62 },
}
